import { render, staticRenderFns } from "./diseno.vue?vue&type=template&id=4f1ba9c0"
import script from "./diseno.vue?vue&type=script&lang=js"
export * from "./diseno.vue?vue&type=script&lang=js"
import style0 from "./diseno.vue?vue&type=style&index=0&id=4f1ba9c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports